// extracted by mini-css-extract-plugin
export default {"homepage":"HomePage_homepage__EAAbV"};